// extracted by mini-css-extract-plugin
export default {"FormLabel":"FormLabel_FormLabel__H-IWZ"};